// extracted by mini-css-extract-plugin
export default {"app_profile":"Home_app_profile__39121","about_title":"Home_about_title__nyw0Z","about_products":"Home_about_products__xW39n","title":"Home_title__XLxL1","hour":"Home_hour__BqxnG"};